
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 491.52 491.52","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F6C358","d":"M0 85.914h491.52v319.69H0z"}}),_c('path',{attrs:{"fill":"#FCD462","d":"M245.76 217.26L491.52 405.6H0z"}}),_c('path',{attrs:{"fill":"#DC8744","d":"M245.76 291.67L0 85.916h491.52z"}}),_c('path',{attrs:{"fill":"#FCD462","d":"M245.76 274.26L0 85.916h491.52z"}})])
          )
        }
      }
    